// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title-cmp[data-v-144219f2] {\n  border-bottom: 2px solid #ddd;\n  padding: 10px 0;\n  font-size: 16px;\n  margin-bottom: 10px;\n  font-weight: bold;\n  color: #12B866;\n}\n", ""]);
// Exports
module.exports = exports;
